import { api } from 'common';

import { MedicalNecessityCheckFormFields } from './FormFields';
import { medicalNecessityCheckDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const medicalNecessityCheckConfig: BlockConfigProps<
  api.FlowDefinition.MedicalNecessityCheckBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'medicalNecessityCheck',
  defaultConfig: {
    diagnoses: '',
    insuranceProvider: '',
    procedureCptCodes: '',
    procedureServiceDate: '',
  },
  configFields: {
    schema: api.FlowDefinition.MedicalNecessityCheckBlockConfigSchema,
    FormFields: MedicalNecessityCheckFormFields,
  },
  documentationMarkdown: medicalNecessityCheckDocumentationMarkdown,
};
